// extracted by mini-css-extract-plugin
module.exports = {"media":"media-module--media--3ipVI","banner":"media-module--banner--1H6Ek","bannerText":"media-module--bannerText--QqzN8"};